import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import {
  FaLaptop,
  FaDownload,
  FaCheckCircle,
  FaUsers,
  FaShieldAlt,
  FaChartLine,
  FaFileInvoiceDollar,
  FaWarehouse,
  FaCog,
  FaStar,
  FaArrowRight,
  FaDesktop,
  FaCloud,
  FaDatabase,
  FaCalculator,
  FaClock,
  FaChevronRight,
  FaChevronLeft,
  FaTimes,
} from "react-icons/fa";
import "./HerkulesPage_new.css";

const HerkulesPage = () => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [currentImageIndex, setCurrentImageIndex] = React.useState(0);
  const galleryImages = [
    "/herkules/viber_image_2025-11-03_13-41-52-473.png",
  ];


  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const features = [
    {
      icon: FaFileInvoiceDollar,
      title: "Podvojné účtovníctvo",
      description:
        "Kompletné účtovníctvo s automatickým generovaním daňových priznaní a reportov",
    },
    {
      icon: FaWarehouse,
      title: "Skladové hospodárstvo",
      description:
        "Evidencia zásob, inventúry, automatické prepočty a optimalizácia skladu",
    },
    {
      icon: FaUsers,
      title: "Personalistika a mzdy",
      description:
        "Kompletná správa zamestnancov, výpočet miezd a sociálnych odvodov",
    },
    {
      icon: FaChartLine,
      title: "Business Intelligence",
      description:
        "Pokročilé reporty, analýzy a grafické zobrazenie výkonnosti firmy",
    },
    {
      icon: FaShieldAlt,
      title: "Bezpečnosť údajov",
      description:
        "Šifrovanie údajov, prístupové práva a audit všetkých operácií",
    },
    {
      icon: FaCog,
      title: "Flexibilné nastavenie",
      description:
        "Prispôsobenie systému podľa špecifických potrieb vašej firmy",
    },
  ];

  const benefits = [
    {
      icon: FaChartLine,
      title: "Zvýšenie efektivity",
      value: "40%",
      description: "Automatizácia účtovných procesov",
    },
    {
      icon: FaClock,
      title: "Úspora času",
      value: "60%",
      description: "Pri spracovaní faktúr a reportov",
    },
    {
      icon: FaFileInvoiceDollar,
      title: "Presnosť údajov",
      value: "99%",
      description: "Eliminovanie ľudských chýb",
    },
    {
      icon: FaUsers,
      title: "Spokojnosť klientov",
      value: "95%",
      description: "S používaním systému Herkules",
    },
  ];

  const packages = [
    {
      name: "Herkules BASIC",
      price: "299€",
      description: "Ideálne pre malé firmy a živnostníkov",
      features: [
        "Základné účtovníctvo",
        "Faktúry a ponuky",
        "Evidencia majetku",
        "Základné reporty",
        "1 používateľ",
        "Email podpora",
      ],
    },
    {
      name: "Herkules STANDARD",
      price: "599€",
      description: "Komplexné riešenie pre stredné firmy",
      features: [
        "Všetky funkcie BASIC",
        "Skladové hospodárstvo",
        "Personalistika a mzdy",
        "Pokročilé reporty",
        "Do 5 používateľov",
        "Online prístup",
        "Prioritná podpora",
      ],
      popular: true,
    },
    {
      name: "Herkules PREMIUM",
      price: "999€",
      description: "Enterprise riešenie pre veľké spoločnosti",
      features: [
        "Všetky funkcie STANDARD",
        "CRM systém",
        "Business intelligence",
        "API integrácie",
        "Neobmedzený počet používateľov",
        "Podpora 24/7",
        "Onsite školenia",
      ],
    },
  ];

  const industries = [
    {
      icon: FaDesktop,
      title: "Malé a stredné podniky",
      description: "Komplexné účtovníctvo pre rastúce firmy",
    },
    {
      icon: FaWarehouse,
      title: "Výrobné spoločnosti",
      description: "Riadenie výroby a skladového hospodárstva",
    },
    {
      icon: FaUsers,
      title: "Služby a konzultácie",
      description: "Personalistika a projektové riadenie",
    },
    {
      icon: FaCloud,
      title: "IT a technológie",
      description: "Flexibilné riešenia pre tech firmy",
    },
  ];

  const testimonials = [
    {
      name: "Ing. Jana Nováková",
      company: "TECHNO s.r.o.",
      text: "Herkules nám úplne zmenil spôsob práce s účtovníctvom. Všetko je prehľadnejšie a rýchlejšie.",
      rating: 5,
    },
    {
      name: "Peter Kovár",
      company: "STAVO PLUS",
      text: "Používame Herkules už 8 rokov a sme maximálne spokojní. Výborná podpora a pravidelné aktualizácie.",
      rating: 5,
    },
  ];

  const openModal = (imageSrc) => {
    const index = galleryImages.indexOf(imageSrc);
    setCurrentImageIndex(index);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

    const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % galleryImages.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
  };

  return (
    <div className="herkules-page">
      {/* Hero Section */}
      <section className="herkules-hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <h1>Herkules 3.0 WIN</h1>
              <h2>Komplexný informačný systém pre riadenie firmy</h2>
              <p>
                Najnovšia verzia obľúbeného účtovníckeho programu Herkules vám
                prináša nové, príjemnejšie užívateľské prostredie a rad ďalších
                noviniek. Ideálne riešenie pre malé, stredné aj veľké firmy s
                kompletným účtovníctvom, skladovým hospodárstvom a
                personalistikou.
              </p>
              <div className="hero-actions">
                <Link to="/kontakt" className="btn btn-primary">
                  <FaArrowRight /> Žiadosť o ponuku
                </Link>
              </div>
            </div>
            <div className="hero-image">
              <img
                src="/hercules.png"
                alt="Herkules 3.0 WIN"
                className="hero-product-image"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="gallery-section">
        <div className="container">
          <h2>Ukážky systému</h2>
          <div className="gallery-grid">
            <div
              className="gallery-item"
              onClick={() =>
                openModal("/herkules/viber_image_2025-11-03_13-41-52-473.png")
              }
            >
              <img
                src="/herkules/viber_image_2025-11-03_13-41-52-473.png"
                alt="Herkules - ukážka 1"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="container">
          <h2>Pokročilé funkcie systému</h2>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-card">
                <div className="feature-icon">
                  <feature.icon />
                </div>
                <h4>{feature.title}</h4>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="benefits-section">
        <div className="container">
          <h2>Výsledky, ktoré môžete očakávať</h2>
          <div className="benefits-grid">
            {benefits.map((benefit, index) => (
              <div key={index} className="benefit-card">
                <div className="benefit-icon">
                  <benefit.icon />
                </div>
                <div className="benefit-value">{benefit.value}</div>
                <h4>{benefit.title}</h4>
                <p>{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Industries Section */}
      <section className="industries-section">
        <div className="container">
          <h2>Vhodné pre všetky typy podnikov</h2>
          <div className="industries-grid">
            {industries.map((industry, index) => (
              <div key={index} className="industry-card">
                <div className="industry-icon">
                  <industry.icon />
                </div>
                <h4>{industry.title}</h4>
                <p>{industry.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="pricing-section">
        <div className="container">
          <h2>Cenové balíčky</h2>
          <div className="pricing-grid">
            {packages.map((pkg, index) => (
              <div
                key={index}
                className={`pricing-card ${pkg.popular ? "popular" : ""}`}
              >
                {pkg.popular && (
                  <div className="popular-badge">Najpopulárnejší</div>
                )}
                <h3>{pkg.name}</h3>
                <div className="price">{pkg.price}</div>
                <p className="price-description">{pkg.description}</p>
                <ul className="features-list">
                  {pkg.features.map((feature, fIndex) => (
                    <li key={fIndex}>
                      <FaCheckCircle />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
                <button className="btn btn-primary">Vybrať balíček</button>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Image Modal */}
      {isModalOpen && (
        <div className="image-modal" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>
              <FaTimes />
            </button>
            <button className="modal-prev" onClick={prevImage}>
              <FaChevronLeft />
            </button>
            <img
              src={galleryImages[currentImageIndex]}
              alt={`FastFood POS - ukážka ${currentImageIndex + 1}`}
            />
            <button className="modal-next" onClick={nextImage}>
              <FaChevronRight />
            </button>
            <div className="modal-counter">
              {currentImageIndex + 1} / {galleryImages.length}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HerkulesPage;
